import React from "react";
import { SvgProps } from ".";

export const ConfirmPaymentSvg: React.FC<SvgProps> = () => {
  return (
    <svg width="73px" height="71px" viewBox="0 0 73 71" version="1.1">
      <title>Confirm-Payment</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-648.000000, -149.000000)">
          <g id="Confirm-Payment" transform="translate(649.000000, 150.000000)">
            <path
              d="M54,0 L65,0 C68.3137085,-6.08718376e-16 71,2.6862915 71,6 L71,45 C71,48.3137085 68.3137085,51 65,51 L6,51 C2.6862915,51 4.05812251e-16,48.3137085 0,45 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 L17,0 L17,0"
              id="Rectangle"
              stroke="#1853A3"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              transform="translate(35.500000, 25.500000) scale(-1, -1) translate(-35.500000, -25.500000) "
            />
            <line
              x1="48.5608977"
              y1="34.9375"
              x2="59.5608977"
              y2="34.9375"
              id="Path"
              stroke="#1853A3"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <line
              x1="32.5608977"
              y1="34.9375"
              x2="37.5608977"
              y2="34.9375"
              id="Path"
              stroke="#1853A3"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <line
              x1="0"
              y1="13"
              x2="71"
              y2="13"
              id="Path"
              stroke="#1853A3"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle
              id="Oval"
              stroke="#F97E53"
              strokeWidth="1.83666667"
              cx="35.5"
              cy="55.5"
              r="13.5816667"
            />
            <polyline
              id="Path"
              stroke="#F97E53"
              strokeWidth="1.58333333"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="42 51 33.3333333 60 29 55.5002009"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default {};
